import React, { useState } from 'react';
import { v1 as uuid } from 'uuid';
import numeral from 'numeral';
// material
import { fade, makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { InputBase, Hidden } from '@material-ui/core';
import { Search as SearchIcon } from '@material-ui/icons';

import ActionButton from '../../components/buttons/ActionButton';

interface Coords {
  accuracy: number;
  altitude: number;
  altitudeAccuracy: number;
  heading: number;
  latitude: number;
  longitude: number;
  speed: number;
}

const MIN_CHAR_SEARCH = 2;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      width: '100%',
    },
    searchContainer: {
      display: 'flex',
      justifyContent: 'center'
    },
    searchText: {
      padding: 20,
      backgroundColor: '#FFF',
      color: '#4A607C',
      borderTopLeftRadius: 4,
      borderBottomLeftRadius: 4,
      border: '1px solid #C9D3E0',
      fontSize: 16
    },
    searchTextMobile: {
      padding: 5,
      textAlign: 'center',
      backgroundColor: '#FFF',
      color: '#4A607C',
      fontSize: 14
    },
    search: {
      position: 'relative',
      borderTop: '1px solid #C9D3E0',
      borderBottom: '1px solid #C9D3E0',
      backgroundColor: '#FFF',
      '&:hover': {
        backgroundColor: fade('#FFF', 0.9),
      },
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        width: 'auto',
      },
      padding: 5
    },
    searchIcon: {
      padding: 15,
      backgroundColor: '#00ABCA',
      borderTopRightRadius: 4,
      borderBottomRightRadius: 4,
      border: '1px solid #C9D3E0'
    },
    inputRoot: {
      color: 'inherit',
      width: 400,
      [theme.breakpoints.down('sm')]: {
        width: 275,
      },
    },
    inputInput: {
      paddingLeft: 20,
      paddingTop: 16,
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: 400,
      },
      [theme.breakpoints.down('sm')]: {
        width: 275,
        paddingLeft: 30
      },
    },
    searchMobile: {
      position: 'relative',
      backgroundColor: fade(theme.palette.common.white, 0.15),
      '&:hover': {
        backgroundColor: fade(theme.palette.common.white, 0.25),
      },
      marginRight: theme.spacing(2),
      marginLeft: 20,
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(3),
        width: 'auto',
      },
    },
    inputRootMobile: {
      color: 'inherit',
      width: 200,
    },
    inputInputMobile: {
      padding: theme.spacing(1, 1, 1, 7),
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: 150,
      },
    }
  }),
);

const token = uuid();

interface SearchInputProps {
  title: string;
  onClick(search: string): void;
}

const SearchInput: React.FC<SearchInputProps> = (props) => {

  const classes = useStyles({});
  const [search, setSearch] = useState<string>('');

  const onChange = (event: any) => {
    let inputText = event.target.value;
    inputText = numeral(inputText).format('$0,0');
    setSearch(inputText);
  }

  const handleClick = () => {
    props.onClick(search);
  }

  return (
    <div style={{ position: 'relative' }}>
      <Hidden smDown>
        <div className={classes.container}>
          <div className={classes.searchContainer}>
            <div className={classes.searchText}>{props.title}</div>
            <div className={classes.search}>
              <InputBase
                value={search}
                onChange={(event) => onChange(event)}
                placeholder="Start typing..."
                classes={{
                  root: classes.inputRoot,
                  input: classes.inputInput,
                }}
                inputProps={{ 'aria-label': 'search' }}
              />
            </div>
            <div className={classes.searchIcon}>
              <SearchIcon style={{ color: '#FFF', fontSize: 30 }} onClick={handleClick} />
            </div>
          </div>
        </div>
      </Hidden>
      <Hidden mdUp>
        <div className={classes.searchTextMobile}>{props.title}</div>
        <div style={{ border: ' 2px solid #00ABCA' }}>
          <div className={classes.search}>
            <InputBase
              value={search}
              onChange={(event) => onChange(event)}
              placeholder="Start typing..."
              classes={{
                root: classes.inputRoot,
                input: classes.inputInput,
              }}
              inputProps={{ 'aria-label': 'search' }}
            />
          </div>
          <div>
            <ActionButton
              name="Search"
              size="sm"
              onClick={handleClick}
              fullWidth
            />
          </div>
        </div>
      </Hidden>
    </div>
  );
}

export default SearchInput;